import { useQuery } from '@tanstack/react-query';

export type ClientAuthState = 'unknown' | 'anonymous' | 'authenticated';

type UserIdResponse = {
    id?: string;
};

function useUserPublicIdQuery() {
    return useQuery<UserIdResponse>({
        queryKey: ['user'],
        queryFn: () => fetch('/home/api/user/id', { cache: 'no-store' }).then((res) => res.json()),
        staleTime: 10 * 60 * 1000, // 10 minutes, means data is considered fresh for 10 minutes
        cacheTime: 30 * 60 * 1000, // 30 minutes, means data is considered stale for 30 minutes
        retry: false,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchOnMount: true,
    });
}

export function useClientAuth(): { authState: ClientAuthState; publicUserId?: string } {
    const { data: user, isLoading } = useUserPublicIdQuery();

    if (isLoading) {
        return { authState: 'unknown' };
    }

    if (user?.id) {
        return { authState: 'authenticated', publicUserId: user.id };
    }

    return { authState: 'anonymous' };
}
